import { Injectable } from '@angular/core';
import { createSelector, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { selectSelectedVehicleBaumuster } from 'src/app/store/common/common.selectors';

import { ConditionResolverOptions, NbaConditionResolver } from '../nba-condition-resolver.interface';

import { NbaConditionResolverId } from './nba-condition-resolver-id.enum';

const isExcludedBaumuster = (baumuster: string): boolean => baumuster.startsWith('!');

const sanitizeBaumuster = (baumuster: string): string =>
  isExcludedBaumuster(baumuster) ? baumuster.slice(1) : baumuster;

// eslint-disable-next-line @typescript-eslint/no-magic-numbers
const toFourCharBaumuster = (baumuster: string): string => baumuster.slice(0, 4);

const selectBaumustersMatchWithVehicleBaumuster = (fourCharBaumusters: string[]): ((state: object) => boolean) => {
  const conditions: Conditions = fourCharBaumusters.reduce<Conditions>(
    (acc: Conditions, baumuster: string) => {
      if (isExcludedBaumuster(baumuster)) {
        acc.exclude.push(sanitizeBaumuster(baumuster));
      } else {
        acc.include.push(baumuster);
      }
      return acc;
    },
    { include: [], exclude: [] }
  );

  return createSelector(selectSelectedVehicleBaumuster, fullBaumuster => {
    if (!fullBaumuster) {
      return false;
    }
    const fourCharBaumuster = toFourCharBaumuster(fullBaumuster);
    return (
      conditions.include.includes(fourCharBaumuster) ||
      (conditions.exclude.length > 0 && !conditions.exclude.includes(fourCharBaumuster))
    );
  });
};

interface Conditions {
  include: string[];
  exclude: string[];
}

@Injectable()
export class IsBmFourResolver implements NbaConditionResolver {
  public readonly identifier: string = NbaConditionResolverId.IsBmFour;

  public constructor(private readonly store: Store) {}

  public resolve$(options?: ConditionResolverOptions): Observable<boolean> {
    const fourCharBaumusters = options?.params || [];
    return this.store.select(selectBaumustersMatchWithVehicleBaumuster(fourCharBaumusters));
  }
}
